import { CSSResultGroup, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { html } from 'lit/static-html.js';

import '../sic-icon/sic-icon';
import defaultVars from './css-variables/vars-default.css.lit';

/**
 * The Chip component.
 * @element sic-chip
 * @slot defaultSlot
 *
 * Lightdom styles in sic-chip.lightdom.css included in /shared.css
 */
@customElement('sic-chip')
export class SicChip extends OutlineElement {
  static styles: CSSResultGroup = [defaultVars];

  /**
   * Whether the link is facet.
   */
  @property({ type: Boolean, attribute: 'is-facet' })
  isFacet = false;

  firstUpdated(): void {
    if (this.isFacet) {
      this.addIcon();
    }
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }

  addIcon() {
    const element = this.querySelector(':scope a');
    const iconName = 'times';
    const iconSize = 'var(--sic-chip-icon-size)';

    const icon = document.createElement('sic-icon');
    icon.setAttribute('size', iconSize);
    icon.setAttribute('name', iconName);
    icon.setAttribute('svg-fill', 'currentColor');
    icon.classList.add('sic-chip--icon-close');
    element?.appendChild(icon);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-chip': SicChip;
  }
}
